import json from './sprite.js';

export default {
    handle: 'en_SPT11-Book-Birthday',
    label: 'en_SPT11-Book-Birthday',
    json,
};
